define('viewmodels/pages/play',['knockout'], function (ko) {

    return function PlayViewModel (router, session, games, navigation, getField) {
        var self = this;

        self.session = session;
        self.gameId = ko.observable();

        self.game = ko.pureComputed(function game () {

            var game = games.mobileGames.getGameBySlug(self.gameId());

            if (!game.exists() && self.gameId()) {
                game = games.desktopGames.getGameBySlug(self.gameId());
            }

            return game;
        });

        self.isDisabled = ko.pureComputed(function isGameDisabled () {
            return self.game().status.disabled();
        });

        self.isMaintenanceMode = ko.pureComputed(function isGameInMaintenanceMode () {
            if (self.isDisabled()) {
                return false;
            }

            return self.game().status.inMaintenanceMode();
        });

        self.isEnabled = ko.pureComputed(function isGameEnabled () {
            if (self.isDisabled()) {
                return false;
            }

            if (self.isMaintenanceMode()) {
                return false;
            }

            return true;
        });

        self.playButtonText = getField('play_button_text');
        self.practiceButtonText = getField('practice_button_text');
        self.signUpText = getField('sign_up_button_text');
        self.trophiesHeading = getField('trophies_heading');
        self.gameInMaintenanceText = getField('game_in_maintenance_text');
        self.gameOnlyOnDesktopText = getField('game_only_on_desktop_text');
        self.allGamesText = getField('all_games_text');

        self.topBarAction = ko.observable();

        self.navigateBack = function navigateBack () {
            if (navigation.canGoBack()) {
                navigation.goBack();
            } else {
                navigation.navigate(navigation.ROUTES.GAMES);
            }
        };

        self.meta = {
            title: self.game.property('metaTitle'),
            description: self.game.property('metaDescription')
        };
        self.activate = function activate (gameId) {
            self.gameId(gameId);
            self.game().load().fail(function () {
                navigation.navigate(navigation.NOT_FOUND);
            });
        };
    };
});

